import { render, staticRenderFns } from "./BusinessNameFormDetails.vue?vue&type=template&id=74bc7ff6&scoped=true&"
import script from "./BusinessNameFormDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessNameFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameFormDetails.vue?vue&type=style&index=0&id=74bc7ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc7ff6",
  null
  
)

export default component.exports